import {
  type PrimitiveValue,
  parseTemplate as parse,
  type Template,
} from "url-template";

// url-template v3 types every variable as required, but the implementation
// follows RFC 6570 and omits any whose value is undefined.
export type ExpandContext = Record<
  string,
  | PrimitiveValue
  | PrimitiveValue[]
  | Record<string, PrimitiveValue | PrimitiveValue[]>
  | undefined
>;

export function parseTemplate(template: string) {
  const parsed = parse(template);

  return {
    expand: (context: ExpandContext) =>
      parsed.expand(context as Parameters<Template["expand"]>[0]),
  };
}
